const cloudflarePattern = /(https?:)?\/\/cdnjs\.cloudflare\.com(\/[\w\.\d]+)*/;

export default cloudflarePattern;